export default __webpack_public_path__ + "static/media/safiya.b1ff0daf.png";